import React from 'react';
import { NewReferralReviewStep } from 'pages/components';

const ReferralsFinalReview = (props) => (
  <NewReferralReviewStep {...props} />
);

export default ReferralsFinalReview;
